angular.module('gym.gocardless', []).config(["$stateProvider", function($stateProvider) {
  return $stateProvider.state('gym.gocardless', {
    abstract: true,
    template: '<ui-view>'
  }).state('gym.gocardless.webhook_logs', {
    url: '/gocardless/webhook_logs',
    controller: 'GoCardlessWebhookLogsCtrl',
    template: require('templates/gyms/gocardless/webhook_logs/index.html.slim')
  }).state('gym.gocardless.api_logs', {
    url: '/gocardless/api_logs',
    controller: 'GoCardlessAPILogsCtrl',
    template: require('templates/gyms/gocardless/api_logs/index.html.slim')
  }).state('gym.gocardless.import_mandates', {
    url: '/gocardless/unallocated_mandates',
    controller: 'GoCardlessImportCtrl',
    template: require('templates/gyms/gocardless/import/index.html.slim')
  });
}]);
